import React from "react";

const Footer = () => {
  return (
    <div className="w-100 text-center py-1 fw-bold footer-text position-relative bottom-0 d-none d-md-block">
      © {new Date().getFullYear()}, HYTECH
    </div>
  );
};

export default Footer;
